import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import ArticleOuter from 'components/ArticleOuter';
import EmptyArticle from 'components/EmptyArticle';
import { MagazineArticleShape } from 'entities';
import MagazineArticlesListPageSelector from './MagazineArticlesListPageSelector';
import './style.scss';
import { getMagazineArticlesOnFrontPage, getMagazinePaging } from 'selectors';
import MagazineArticle from 'containers/MagazineArticle';
import MagazineArticlesSidebar from 'containers/MagazineArticlesSidebar';
import queries, { normalizeMagazineQuery } from 'magazineQueries';

class MagazineArticlesList extends Component {

  renderRestOfTheMagazineArticles() {
    return this.props.magazineArticles.slice(1).map(magazineArticle => {
      return (
        <ArticleOuter key={magazineArticle.id}>
          <MagazineArticle
            magazineArticle={magazineArticle}
            imageUrl={magazineArticle.thumbnail.preview.lowRes}
            shouldOpenProfileFromImage
            />
        </ArticleOuter>
      );
    });
  }

  renderEmptyArticles() {
    return (
      <div>
        <ArticleOuter>
          <EmptyArticle />
        </ArticleOuter>

        <ArticleOuter>
          <EmptyArticle />
        </ArticleOuter>

        <ArticleOuter>
          <EmptyArticle />
        </ArticleOuter>
      </div>
    );
  }

  render() {
    return (
      <div className="MagazineArticlesList">
        <div className="wrapper-xlarge is-collapsed has-small-background">
          {(() => {
            if(this.props.showsFeaturedArticle) {
              return (
                <MagazineArticle
                  magazineArticle={this.props.magazineArticles[0]}
                  isFeatured
                  imageUrl={this.props.magazineArticles[0].thumbnail.preview.highRes}
                  shouldOpenProfileFromImage
                  />
              );
            }
            else if(this.props.isFetching) {
              return <EmptyArticle isFeatured />;
            }
          })()}

          <div className="articles-list-wrapper">
            <div className="list">
              {(() => {
                if(this.props.showsArticlesList) {
                  return this.renderRestOfTheMagazineArticles();
                }
                else if(this.props.isFetching) {
                  return this.renderEmptyArticles();
                }
              })()}
            </div>

            <MagazineArticlesSidebar queries={queries} selectedQueryString={this.props.queryString} />
          </div>
        </div>

        <div className="pagination-wrapper">
          <div className="wrapper-xlarge">
            {this.props.pagesCount > 1 && <MagazineArticlesListPageSelector query={this.props.query} queryString={this.props.queryString}  />}
          </div>
        </div>
      </div>
    );
  }
}

MagazineArticlesList.propTypes = {
  magazineArticles: PropTypes.arrayOf(MagazineArticleShape),
  isFetching: PropTypes.bool,
  pagesCount: PropTypes.number,
  onFetchCurrentPage: PropTypes.func,
  queryString: PropTypes.string,
  query: PropTypes.object,
  showsFeaturedArticle: PropTypes.bool,
  showsArticlesList: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const query = normalizeMagazineQuery(props.location.query);
  const queryString = JSON.stringify(query);
  const { page, isFetching, pagesCount } = getMagazinePaging(state, 'magazineArticles', { queryString });
  const magazineArticles = getMagazineArticlesOnFrontPage(state, { page, queryString });

	return {
    magazineArticles,
    showsFeaturedArticle: magazineArticles.length >= 1,
    showsArticlesList: magazineArticles.length > 1,
    isFetching,
    queryString,
    query,
    pagesCount
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MagazineArticlesList);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Magazine/MagazineArticlesList/index.js
 **/